import { render, staticRenderFns } from "./CanvasWritingBoard.vue?vue&type=template&id=f541b2e4&scoped=true&"
import script from "./CanvasWritingBoard.vue?vue&type=script&lang=js&"
export * from "./CanvasWritingBoard.vue?vue&type=script&lang=js&"
import style0 from "./CanvasWritingBoard.vue?vue&type=style&index=0&id=f541b2e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f541b2e4",
  null
  
)

export default component.exports